import { Button } from "antd";
import React, { useState } from "react";
import ModalChangePassword from "../modal/ModalChangePassword";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonChangePasswordProps {
  accountId: string;
}

const ButtonChangePassword: React.FC<ButtonChangePasswordProps> = (
  props: ButtonChangePasswordProps
) => {
  const { accountId } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);  useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button onClick={showModal} className="font-medium">
        Đổi mật khẩu
      </Button>
      <ModalChangePassword accountId={accountId} onClose={handleCancel} visible={isModalOpen} />
    </div>
  );
};

export default ButtonChangePassword;
